/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Cart Events Handler
const CartEvents = {
    init() {
        // Listen for cart updates
        document.addEventListener('theme:cart:update', () => {
            setTimeout(() => this.updateEstimatedRRP(), 500);
        });

        // Listen for cart additions
        document.addEventListener('theme:cart:add', () => {
            setTimeout(() => this.updateEstimatedRRP(), 500);
        });

        // Listen for cart removals
        document.addEventListener('theme:cart:remove', () => {
            setTimeout(() => this.updateEstimatedRRP(), 500);
        });

        // Listen for minicart open
        document.addEventListener('theme:cart:open', () => {
            setTimeout(() => this.updateEstimatedRRP(), 500);
        });

        // Listen for cart drawer updates
        document.addEventListener('theme:cart:drawer:update', () => {
            setTimeout(() => this.updateEstimatedRRP(), 500);
        });

        // Handle remove button clicks
        document.addEventListener('click', (e) => {
            const removeButton = e.target.closest('[data-item-remove]');
            if (removeButton) {
                // Get the cart item container
                const cartItem = removeButton.closest('.cart-item');
                if (cartItem) {
                    const estimatedRRP = cartItem.querySelector('.estimated-rrp')?.textContent || '0.00';
                    // Store the RRP value before item is removed
                    this.lastRemovedItemRRP = parseFloat(estimatedRRP.replace(/[^0-9.]/g, '')) || 0;
                }

                // Wait for theme.dev.js to finish its updates
                const checkCartUpdate = setInterval(() => {
                    const cartDrawer = document.querySelector('#cartItemsHolder');
                    if (cartDrawer) {
                        clearInterval(checkCartUpdate);
                        this.updateEstimatedRRP();
                    }
                }, 100);

                // Safety timeout after 2 seconds
                setTimeout(() => {
                    clearInterval(checkCartUpdate);
                    this.updateEstimatedRRP();
                }, 2000);
            }
        });

        // Wait for theme.dev.js to be ready
        const waitForTheme = setInterval(() => {
            if (document.querySelector('#cartItemsHolder')) {
                clearInterval(waitForTheme);
                this.updateEstimatedRRP();
            }
        }, 100);

        // Safety timeout after 2 seconds
        setTimeout(() => {
            clearInterval(waitForTheme);
            this.updateEstimatedRRP();
        }, 2000);
    },

    lastRemovedItemRRP: 0,

    // updateEstimatedRRP() {
    //     // Try to find items in cart drawer first
    //     let items = document.querySelectorAll('#cartItemsHolder [data-cart-estimated-rrp-item]');
    //     if (!items || items.length === 0) {
    //         // Fallback to main cart items
    //         items = document.querySelectorAll('#cartItemsHolder [data-cart-estimated-rrp-item]');
    //     }

    //     let total = 0;

    //     if (items && items.length > 0) {
    //         items.forEach((item) => {
    //             const priceStr = item.getAttribute('data-cart-estimated-rrp-item');
    //             if (priceStr) {
    //                 const cleanPrice = priceStr.replace(/[^0-9.]/g, '');
    //                 const price = parseFloat(cleanPrice);
    //                 if (!isNaN(price)) {
    //                     total += price;
    //                 }
    //             }
    //         });
    //     }

    //     // Update all elements with data-cart-estimated-rrp-price
    //     const priceElements = document.querySelectorAll('[data-cart-estimated-rrp-price]');
    //     if (priceElements.length > 0) {
    //         priceElements.forEach(el => {
    //             const currencySymbol = el.getAttribute('data-money') || '$';
    //             el.textContent = currencySymbol + total.toFixed(2);
    //             el.setAttribute('data-cart-estimated-rrp-price', total.toFixed(2));
    //         });
    //     } else {
    //         // Try to find the estimated RRP elements by class
    //         const estimatedRRPElements = document.querySelectorAll('.estimated-rrp-total');
    //         estimatedRRPElements.forEach(el => {
    //             const currencySymbol = el.getAttribute('data-money') || '$';
    //             el.textContent = currencySymbol + total.toFixed(2);
    //             el.setAttribute('data-cart-estimated-rrp-price', total.toFixed(2));
    //         });
    //     }
    // }

    updateEstimatedRRP(retry = 0) {
        let items = document.querySelectorAll('#cartItemsHolder [data-cart-estimated-rrp-item]');
        // 🔥 IMPORTANT: retry logic (max 5 times)
        if ((!items || items.length === 0) && retry < 5) {
            setTimeout(() => {
                this.updateEstimatedRRP(retry + 1);
            }, 200);
            return;
        }
        let total = 0;
        if (items && items.length > 0) {
            items.forEach((item) => {
                const priceStr = item.getAttribute('data-cart-estimated-rrp-item');
                if (priceStr) {
                    const cleanPrice = priceStr.replace(/[^0-9.]/g, '');
                    const price = parseFloat(cleanPrice);
                    if (!isNaN(price)) {
                        total += price;
                    }
                }
            });
        }

        const priceElements = document.querySelectorAll('[data-cart-estimated-rrp-price]');
        if (priceElements.length > 0) {
            priceElements.forEach(el => {
                const currencySymbol = el.getAttribute('data-money') || '$';
                // 🔥 BLANK FIX
                const finalValue = isNaN(total) ? 0 : total;
                el.textContent = currencySymbol + finalValue.toFixed(2);
                el.setAttribute('data-cart-estimated-rrp-price', finalValue.toFixed(2));
                const wrapper = el.closest('.cart__estimated-rrp');
                if (wrapper) {
                    if (finalValue <= 0) {
                        wrapper.style.display = 'none';
                    } else {
                        wrapper.style.display = '';
                    }
                }
            });
        }
    }
};

(function () {
    if (typeof productCleanOutKit !== 'undefined' && productCleanOutKit !== null) {
        fetch('/cart.js').then(response => response.json()).then(cart => {
            const hasCleanOutKit = cart.items.some(item => item.product_id == productCleanOutKit);
            if(hasCleanOutKit) {
              const cartAsideMessage = document.querySelector('.cart__aside .cart__message');
              const cartDrawerMessage = document.querySelector('.cart-drawer__message');
              const cartDrawerRrp = document.querySelector('.cart__estimated-rrp');
              const cartDrawerFoot= document.querySelector('.cart-drawer__foot');
              if(cartAsideMessage) {
                cartAsideMessage.style.display = 'none';
              }
              if(cartDrawerFoot) {
                cartDrawerFoot.classList.add('rrp-hidden');
              }
              if(cartDrawerMessage) {
                cartDrawerMessage.style.display = 'none';
              }
              if(cartDrawerRrp) {
                cartDrawerRrp.style.display = 'none';
              }
            }
        }).catch(error => console.error('Error fetching cart:', error));
    }
    // Cache DOM elements
    const announcementBar = document.querySelector('.announcement-bar-static');
    const siteHeader = document.querySelector('.site-header');

    // Function to update the sticky header height CSS variable
    const updateHeaderHeight = () => {
        const announcementHeight = announcementBar?.offsetHeight || 0;
        const headerHeight = siteHeader?.offsetHeight || 0;
        const combinedHeight = announcementHeight + headerHeight;

        document.documentElement.style.setProperty('--header-sticky-custom-height', combinedHeight + 'px');
    };

    // Function to handle scroll event
    let lastScrollTop = 0; // To keep track of the last scroll position
    const SiteHeader = document.querySelector('.shopify-section-header');
    const handleScroll = () => {
        const scrollY = window.scrollY || window.pageYOffset;
        const announcementHeight = announcementBar?.offsetHeight || 0;
        const headerHeight = siteHeader?.offsetHeight || 0;
        const combinedHeight = announcementHeight + headerHeight;

        let currentScroll = window.pageYOffset || document.documentElement.scrollTop;

        // Adjust header height based on scroll position and class
        if (document.body.classList.contains('has-scrolled')) {
            document.documentElement.style.setProperty('--announcement-custom-height', '0px');

            // Scroll Down
            if (currentScroll > lastScrollTop) {
                SiteHeader.classList.remove('show');
                document.documentElement.style.setProperty('--header-sticky-custom-height', '0px');
            }
            // Scroll Up
            else {
                SiteHeader.classList.add('show');
                document.documentElement.style.setProperty('--header-sticky-custom-height', headerHeight + 'px');
            }
        } else {
            document.documentElement.style.setProperty('--header-sticky-custom-height', Math.max(combinedHeight - scrollY, 0) + 'px');
            SiteHeader.classList.remove('show');
            document.documentElement.style.setProperty('--header-sticky-custom-height', headerHeight + 'px');
            if (scrollY <= announcementHeight) {
                document.documentElement.style.setProperty('--announcement-custom-height', announcementHeight - scrollY + 'px');
            } else {
                document.documentElement.style.setProperty('--announcement-custom-height', '0px');
                if (scrollY >= announcementHeight && scrollY <= (headerHeight + announcementHeight)) {
                    document.documentElement.style.setProperty('--header-sticky-custom-height', headerHeight - scrollY + announcementHeight + 'px');
                } else {
                    document.documentElement.style.setProperty('--header-sticky-custom-height', '0px');
                }
            }
        }

        // Update the last scroll position
        lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    };

    // Attach event listeners for load and resize events
    window.addEventListener('load', () => {
        updateHeaderHeight();
        handleScroll(); // Ensure correct height calculation on page load
        CartEvents.init(); // Initialize cart events after DOM is loaded
    });
    window.addEventListener('resize', updateHeaderHeight);
    window.addEventListener('scroll', handleScroll);


    // Initial update when script loads
    updateHeaderHeight();
    handleScroll(); // Ensure correct header behavior on initial page load


    // Function to apply tooltips to eligible elements
    function applyTooltips() {
        document.querySelectorAll('.tooltip-button-svg:not(.applied)').forEach(function (button) {
            const nextContent = button.nextElementSibling;

            // Ensure the next element has the tooltip content
            if (nextContent && nextContent.classList.contains('tooltip-content')) {
                tippy(button, {
                    content: nextContent.innerHTML, // Tooltip content from adjacent element
                    allowHTML: true,                // Enable HTML rendering
                    placement: 'bottom-end',        // Tooltip position
                    offset: [20, 0],                // Tooltip offset
                    maxWidth: 248                   // Max width of tooltip
                });

                button.classList.add('applied'); // Mark as processed to avoid reinitializing
            }
        });
    }

    // Run applyTooltips repeatedly for 5 seconds (20 times per second)
    let count = 0;
    const interval = setInterval(() => {
        applyTooltips();
        count++;
        if (count >= 100) clearInterval(interval); // Stop after 5 seconds
    }, 50);

    // Re-apply on AJAX complete (jQuery)
    if (typeof jQuery !== 'undefined') {
        jQuery(document).ajaxComplete(() => {
            applyTooltips();
        });
    }

    // Re-apply on fetch complete (override fetch)
    const originalFetch = window.fetch;
    window.fetch = function (...args) {
        return originalFetch(...args).then(response => {
            setTimeout(() => {
                applyTooltips(); // Re-apply tooltips after response
            }, 100);
            return response;
        });
    };
})();